import {
  PricingDataResponse,
  SubmitOrderRequest,
  SubmitOrderResponse,
} from './apiTypes';
import { emptyApiSlice } from './emptyApiSlice';

const isStandalone = process.env.REACT_APP_TYPE === 'standalone';

export const paymentApiSlice = emptyApiSlice.injectEndpoints({
  endpoints: builder => ({
    getPricingData: builder.query<PricingDataResponse, void>({
      query: () => ({
        url: '/purchase/get-pricing-data',
        method: 'GET',
      }),
      providesTags: ['Pricing'],
    }),
    submitOrder: builder.mutation<SubmitOrderResponse, SubmitOrderRequest>({
      query: ({ ai_signal_core, ai_signal_domain, payment_interval }) => {
        // NEEDS TO BE REFACTORED! FROM BACKEND SIDE AS WELL
        // New dynamic mapping body shape:
        // Input: { ai_signal_core: 'domain1.com', ai_signal_domain: ['domain2.com','domain3.com'] }
        // Outgoing body: { 'domain1.com': 'ai_signal_core', 'domain2.com': 'ai_signal_domain', 'domain3.com': 'ai_signal_domain' }
        const mappingBody: Record<string, string> = {};
        if (ai_signal_core && ai_signal_core.trim() !== '') {
          mappingBody[ai_signal_core.trim()] = 'ai_signal_core';
        }
        if (Array.isArray(ai_signal_domain) && ai_signal_domain.length > 0) {
          ai_signal_domain.forEach(d => {
            const trimmed = (d || '').trim();
            if (trimmed !== '') {
              mappingBody[trimmed] = 'ai_signal_domain';
            }
          });
        }
        // Determine effective language (explicit param overrides stored value)
        const language = localStorage.getItem('locale')?.trim();
        let url = '/purchase/submit-order';
        if (language || isStandalone) {
          url += `?lang=${language ? encodeURIComponent(language) : 'en'}`;
        }
        const requestBody = {
          domains: mappingBody,
          ...(payment_interval
            ? { extra: { one_month_subscription: payment_interval } }
            : {}),
        };
        return {
          url,
          method: 'POST',
          body: requestBody,
          // Backend may respond with plain text (e.g. "Package purchase sucessfully completed.")
          // Use text response handler to avoid JSON parse failure and map to structured object.
          responseHandler: 'text',
          validateStatus: (response: Response, _body: unknown) =>
            response.status >= 200 && response.status < 300,
        };
      },
      transformResponse: (raw: string | SubmitOrderResponse) => {
        if (typeof raw === 'string') {
          try {
            const maybeJson = JSON.parse(raw);
            return maybeJson;
          } catch (_) {
            return { success: true, message: raw } as SubmitOrderResponse;
          }
        }
        return raw;
      },
      invalidatesTags: [
        'UserInfo',
        'BusinessInfo',
        'BusinessInsights',
        'Metrics',
        'VisibilityRules',
        'VisibilityScore',
        'TargetAudience',
        'GeographicFocus',
        'BusinessAddress',
        'BusinessName',
      ],
    }),
  }),
});

export const { useGetPricingDataQuery, useSubmitOrderMutation } =
  paymentApiSlice;
